import { render, staticRenderFns } from "./NewDemandsChart.vue?vue&type=template&id=619b3216&scoped=true&"
import script from "./NewDemandsChart.vue?vue&type=script&lang=js&"
export * from "./NewDemandsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619b3216",
  null
  
)

export default component.exports